import { Delete, Edit } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCompany_management_deleteMutation,
  useCompany_management_listMutation,
  useLazyCompany_management_statusQuery,
} from "../../constants/redux/api/api";
import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import Swal from "sweetalert2";
import { loadergif } from"../../assets/img";

function Table({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <>
      <BTable size="sm" responsive {...getTableProps()} variant="dark">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>
      <Row className="justify-content-between table-show my-2">
        <Col>
          <Pagination className="justify-content-end " size="lg">
            <Pagination.First
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            />
            <Pagination.Prev
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            />
            <Pagination.Next
              onClick={() => nextPage()}
              disabled={!canNextPage}
            />
            <Pagination.Last
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            />
          </Pagination>
        </Col>
      </Row>
    </>
  );
}

const CompanyList = () => {
  const navigate = useNavigate();
  const [comapnyManageList, setCompanyManagementList] = useState([]);
  const [loading, setLoading] = useState(false);
  // RTK Query
  const [company_management_list] = useCompany_management_listMutation();
  const [company_management_status] = useLazyCompany_management_statusQuery();
  const [comapny_delete] = useCompany_management_deleteMutation();

  const GetCompanyManagementList = async () => {
    setLoading(true)
    company_management_list()
      .unwrap()
      .then((res) => {
        setLoading(false)
        if (res?.status === "success") {
          let temp = [];
          res?.data?.map((item, ind) => {
            temp.push(item);
          });

          setCompanyManagementList(temp.reverse());
        }
      })
      .catch((err) => {
        setLoading(false)
        console.log(err, "error");
      });
  };

  const companyDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        comapny_delete(id)
          .unwrap()
          .then((res) => {
            GetCompanyManagementList();
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    });
  };

  useEffect(() => {
    GetCompanyManagementList();
  }, []);

  //   change status
  const handleChangeStatus = (id) => {
    if (id) {
      setLoading(true)
      company_management_status(id)
        .unwrap()
        .then((res) => {
          setLoading(false)
          if (res?.status === "success") {
            GetCompanyManagementList();
          }
        })
        .catch((err) => {
          setLoading(false)
          console.log(err, "err");
        });
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Company Name",
        accessor: "companyname",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Contact Name",
        accessor: "clientname",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Contact Number",
        accessor: "contactnumber",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => {
                handleChangeStatus(row.original._id);
              }}
              className={`${
                value ? "bg-success" : "bg-danger"
              } px-2 py-1 rounded-1 border-0 text-white`}
            >
              {value ? "Active" : "Deactive"}
            </button>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex justify-content-center gap-2">
              <button
                onClick={() =>
                  navigate("/add-company", {
                    state: { type: "edit", data: row.original },
                  })
                }
                className="bg-primary text-white border-0 rounded-1 p-1 me-2"
              >
                <Edit />
              </button>
              {/* <button
                className="bg-warning border-0 rounded-1 p-1"
                onClick={() => companyDelete(row.original._id)}
              >
                <Delete />
              </button> */}
               <button
                onClick={() =>
                  navigate("/add-company", {
                    state: { type: "view", data: row.original },
                  })
                }
                type="button"
                className="btn btn-secondary text-white border-0 rounded-1 p-1 me-2"
              >
                <VisibilityIcon />
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
    {loading && (
      <div
        style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}>  
        <span style={{ marginLeft: 10 }}><img src={loadergif}/></span>
      </div>
    )}
    <div className="table-responsive menu-table side_pad mt-4">
      <Table columns={columns} data={comapnyManageList} className="" />
    </div>
    </>
  );
};

export default CompanyList;
